import Configs from "@/views/configs/index.vue";
import Users from "./user.js";

import HMAConfig from "./hma";
import HPPConfig from "./hpp";
import HFConfig from "./hf";
import BioFacilitators from "./biomicroscopy";
import FundoscopyFacilitators from "./fundoscopy";
import GlassesPrescriptionConfig from "./glasses_prescription";
import MedicationHistoryConfig from "./medication_history";
import AllergyConfig from "./allergy";
import MedicineConfig from "./medicine";
import DiagnosticHypothesisConfig from "./diagnostic_hypothesis";
import ConductConfig from "./conduct";
import PrescriptionConfig from "./prescription";
import TemplateConfig from "./template";
import ServiceConfig from "./service";
import AppraisalConfig from "./appraisal";
import ContactLenConfig from "./contact_len";
import SurgeryConfig from "./surgery";
import ProsthesisConfig from "./prosthesis";
import AttendancePlaceConfig from "./attendance_place";
import MedicalReportTemplateConfig from "./medical_report_template";
import ExamReportConfig from "./exam_report";

import DefaultLayout from "@/views/layouts/default.vue";

export default [
  {
    path: "/configuracoes",
    component: DefaultLayout,
    children: [
      {
        path: "/",
        name: "Configurações",
        meta: { title: "Configurações" },
        component: Configs,
        children: [].concat(
          Users,
          HMAConfig,
          HPPConfig,
          HFConfig,
          BioFacilitators,
          FundoscopyFacilitators,
          GlassesPrescriptionConfig,
          MedicationHistoryConfig,
          AllergyConfig,
          MedicineConfig,
          DiagnosticHypothesisConfig,
          ConductConfig,
          PrescriptionConfig,
          TemplateConfig,
          ServiceConfig,
          AppraisalConfig,
          ContactLenConfig,
          SurgeryConfig,
          ProsthesisConfig,
          AttendancePlaceConfig,
          MedicalReportTemplateConfig,
          ExamReportConfig,
        ),
      },
    ],
  },
];
